import { axiosGeneric } from '../../config/axiosConfig';
import API from '../../API/ApiURL';
import { alertErrorResponse } from '../../utils/alertResponseHttpUtil';

const RUTA_IT_MANAGEMENT = `${API.generic}It-Management`;

export default {
  async buscarCxCPorCompania(IdCia, nitTercero) {
    try {
      const response = await axiosGeneric.get(
        `${RUTA_IT_MANAGEMENT}/getEstadoCxC`,
        {
          params: {
            IdCia,
            NitTercero: nitTercero,
          },
        }
      );

      return response.data.detail;
    } catch (error) {
      alertErrorResponse(error.response?.data);
    }
  },

  async autenticarApiGeneric() {
    try {
      const response = await axiosGeneric.post(
        `${API.generic}login/authenticate`,
        {
          Username: API.userGeneric,
          Password: API.passwordGeneric,
        }
      );

      return response.data;
    } catch (error) {
      alertErrorResponse(error.response?.data);
    }
  },
};
